import React, { useContext, useEffect, useState } from "react";
import classes from "./ForecastsYearPage.module.css"
import { backend_routes } from "../../../common/links";
import MyLoadingIcon from "../../UI/loadingIcon/MyLoadingIcon";
import {useAxiosDeleteRefreshing, useAxiosGetRefreshing} from "../../../hooks/useAxios"
import Forecast from "../../forecast/forecast"

const ForecastsYearPage = function(){
    const [fetchForecasts, isFetchLoading] = useAxiosGetRefreshing(
        function(response){
            let fcNew = [];
            for (let fc of response.data.data){
                const fcItem = {
                    id: fc.id,
                    theme: fc.theme,
                    kind: "year",
                    content: fc.content,
                    fileUrl: fc.fileUrl,
                    date: fc.year
                }
                fcNew.push(fcItem);
            }
            setForecasts([...fcNew]);
        }
    );

    const [forecasts, setForecasts] = useState([]);

    useEffect(()=>{
        fetchForecasts(backend_routes.FORECASTS_ALL_YEARS);
    },[]);


    var deletingId;
    const handleChildElementClick = (e, id) => {
        e.stopPropagation();
        deletingId = id;
        deleteFC(backend_routes.FORECASTS_DELETE_LINK+"year/"+id)
    }
    const [deleteFC, isDeleteSending] = useAxiosDeleteRefreshing(
        async function (response) {
            if (response.data.data===204){
                setForecasts(forecasts.filter(p => p.id !== deletingId));
            }
        },
        function (badResponse) {
            deletingId = 0;
            console.log(badResponse);
        }
    );

    const forecastChangingCallback = function(){
        setForecasts([...forecasts]);
    }

    return(
        <div className={classes.forecastsYearPage}>
            {
            isFetchLoading || isDeleteSending
            ? <MyLoadingIcon/>
            : forecasts.map(item => <Forecast key={item.id} forecast={item}>
                <div className="deleteButton" onClick={(e) => handleChildElementClick(e, item.id)}>Удалить</div>
            </Forecast>)            
            }
        </div>
    );
}
export default ForecastsYearPage;